module.exports = __webpack_public_path__ + "img/history.8137d5a1.png";